export default {
  meta: {
    title: '机会点',
  },
};
